import { useState } from "react";

export default function ContactRequestAnswer({ token }) {
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState(""); // <-- nouveau champ
  const [request, setRequest] = useState("");
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const API_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");

    try {
      const response = await fetch(`${API_URL}/admin/answer_contact_request.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ email, subject, request, answer }), // <-- inclut subject
      });

      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.error || `Erreur ${response.status}`);
      }

      const data = await response.json();
      setSuccessMessage(data.message || "Réponse envoyée avec succès !");
      setEmail("");
      setSubject("");  // <-- réinitialisation
      setRequest("");
      setAnswer("");
    } catch (err) {
      setErrorMessage(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-request-answer">
      <h3>Répondre à une demande de contact</h3>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Email :</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="Email de l'utilisateur"
          />
        </div>

        <div className="form-group">
          <label>Objet :</label>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
            placeholder="Sujet du mail"
          />
        </div>

        <div className="form-group">
          <label>Demande :</label>
          <textarea
            value={request}
            onChange={(e) => setRequest(e.target.value)}
            placeholder="Texte de la demande"
          />
        </div>

        <div className="form-group">
          <label>Réponse :</label>
          <textarea
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            required
            placeholder="Votre réponse"
          />
        </div>

        <button type="submit" disabled={loading}>
          {loading ? "Envoi..." : "Envoyer la réponse"}
        </button>

        {successMessage && <p className="success">{successMessage}</p>}
        {errorMessage && <p className="error">{errorMessage}</p>}
      </form>

      <style jsx>{`
        .contact-request-answer {
          padding: 1rem;
          margin: 1rem 0;
          border-radius: 6px;
          background-color: #fafafa;
        }
        .form-group {
          margin-bottom: 1rem;
        }
        label {
          display: block;
          font-weight: bold;
          margin-bottom: 0.3rem;
        }
        input,
        textarea {
          width: 90%;
          margin-left: 1rem;
          margin-right: 1rem;
          padding: 0.5rem;
          border-radius: 4px;
          border: 1px solid #ccc;
        }
        button {
          padding: 0.6rem 1.2rem;
          background-color: #A64343;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }
        button:disabled {
          background-color: #999;
          cursor: not-allowed;
        }
        .success {
          color: green;
          margin-top: 0.5rem;
        }
        .error {
          color: red;
          margin-top: 0.5rem;
        }
      `}</style>
    </div>
  );
}
